import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import React from 'react';

export default function PaypalProvider(props: {
  children: JSX.Element;
  clientId: string;
}) {
  return (
    <PayPalScriptProvider
      options={{
        'client-id': props.clientId,
        currency: 'USD',
        intent: 'capture',
      }}
    >
      {props.children}
    </PayPalScriptProvider>
  );
}
